/**
 * 推送服务出口（项目定制层）
 * 由通用插件 @/plugins/uni-push + 项目配置 push.config.ts 组装而成
 * 使用：App.vue onLaunch 中调用 pushService.init()（不要 await，H5 端可能不回调）
 */
import { createUniPush } from '@/plugins/uni-push';
import { usePushStore } from '@/store';
import { pushConfig } from './push.config';

/** 插件实例（通用能力：init / handleMessage / getStatus / 权限检查 / 角标） */
const push = createUniPush(pushConfig);

export const pushService = {
  /** 初始化推送（注册监听、获取 clientId、检查通知权限） */
  init: () => push.init(),

  /** 手动检查通知权限（如设置页调用） */
  checkNotificationPermission: () => push.checkNotificationPermission(),

  /** 手动触发消息处理（测试页构造消息用） */
  handleMessage: push.handleMessage.bind(push),

  /**
   * 获取推送运行时状态（用于调试/页面展示，判断 uni-push 是否启用并完成初始化）
   */
  getStatus: () => push.getStatus(),

  /** 清空未读数并同步清除 App 角标（App onHide 时调用） */
  clearBadge() {
    usePushStore().clearUnreadCount();
  },
};

export type { PushMessage, PushPayloadData } from '@/plugins/uni-push';
export { PushEventType } from '@/plugins/uni-push';
